import { render, staticRenderFns } from "./wordCheckbox.vue?vue&type=template&id=20cdcbe0&"
import script from "./wordCheckbox.vue?vue&type=script&lang=js&"
export * from "./wordCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./wordCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports